import React, { Component } from 'react';
import { createRoot } from 'react-dom/client';
import { createPortal } from 'react-dom';
import './InputMessageModal.css';

class InputMessageModal extends Component {
  constructor(props) {
    super(props);
    this.container = document.createElement('div');
    document.body.appendChild(this.container);
    this.root = createRoot(this.container);
  }

  static show(message, onOk, onCancel) {
    const modalInstance = new InputMessageModal({
      message,
      onOk,
      onCancel,
    });
    modalInstance.renderModal();
    return modalInstance;
  }

  closeModal = () => {
    this.root.unmount();
    document.body.removeChild(this.container);
  }

  renderModal() {
    const handleOk = () => {
      const inputValue = document.getElementById('input-field').value;
      if (this.props.onOk) this.props.onOk(inputValue, this.closeModal);
    };

    const handleCancel = () => {
      this.closeModal();
      if (this.props.onCancel) this.props.onCancel();
    };

    this.root.render(
      <InputMessageModal
        message={this.props.message}
        onOk={handleOk}
        onCancel={handleCancel}
      />
    );
  }

  render() {
    return createPortal(
      <div className="input-message-modal">
        <div className="modal" onClick={e => e.stopPropagation()}>
          <div className="input-message-modal-content">
            <div>
              <p>{this.props.message}</p>
              <input type="password" id="input-field" className="input-field" />
              <div className="input-message-buttons-container">
                <button className="btn ok-button" onClick={this.props.onOk}>確認</button>
                <button className="btn cancel-button" onClick={this.props.onCancel}>取消</button>
              </div>
            </div>
          </div>
        </div>
      </div>,
      document.body
    );
  }
}

export default InputMessageModal;
